export const assertAllDefined = (forState: string, ...values: unknown[]) => {
  const nullValues = values.filter(v => !v);
  if(nullValues.length > 0) {
    console.error(`Invalid state for ${forState}, expected all values to be defined, but ${nullValues.length} were not`);
    throw new Error(`Invalid state for ${forState}, expected all values to be defined, but ${nullValues.length} were not`)
  }
}